
const tiltleAnchor = (id) => {
  const anchor = document.createElement('a')
  anchor.id = id
  anchor.classList.add('anchor');
  return anchor
}

const extractId = (elt) => {
  return elt.textContent.replace(/\s+/g, '').substr(0, 12) + '_' + elt.salt
}

const tableOfContentExtractedObject = (elt) => {
  return {
    id: extractId(elt),
    title: elt.textContent,
    type: elt.tagName == "H2" ? 'title' : 'subtitle'
  }
}

const htmlStringTraverse = (content, callback, filter=(elt)=>(true)) => {
  const parsed = (new DOMParser()).parseFromString(content, "text/html");
  for (
    let element = parsed.getElementsByTagName('body')[0].firstElementChild;
    element;
    element = element.nextSibling
  ) {
    if(filter(element)) {
      element.salt = Math.random().toString(36).slice(2, 7);
      callback(element)
    }
  }
  return parsed.getElementsByTagName('body')[0].innerHTML
}

const navigableContent = (content) => {
  let tableOfContentArray = [];
  const taggedInnerHtml = htmlStringTraverse(
    content,
    (element)=>{
      tableOfContentArray.push(tableOfContentExtractedObject(element))
      element.before(tiltleAnchor(extractId(element)));
    },
    (element)=>(['H2', 'H3'].includes(element.tagName)))
  return [taggedInnerHtml, tableOfContentArray]
}

export default navigableContent